import React, { useEffect, useState } from "react"
import { isMidDesktop, isMobile, isTablet } from "../utility"

const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState<
    "desktop" | "mobile" | "tablet" | "midDesktop"
  >("desktop")
  useEffect(() => {
    if (window) {
      const getDevice = () =>
        isMobile(window)
          ? setDeviceType("mobile")
          : isTablet(window)
          ? setDeviceType("tablet")
          : isMidDesktop(window)
          ? setDeviceType("midDesktop")
          : setDeviceType("desktop")

      getDevice()

      window.addEventListener("resize", () => {
        getDevice()
      })

      return () => {
        window.removeEventListener("resize", () => {})
      }
    }
  }, [])

  return deviceType
}

export default useDeviceType
